import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import PlaylistsListGrid from './PlaylistsListGrid';
import {AdminHeader} from "@/pages/ManagerView/AdminHeader";

const useStyles = makeStyles()((theme) => ({
  betaDisclaimer: {
    position: 'relative',
    fontStyle: 'italic',
    top: theme.spacing(-3),
    marginBottom: theme.spacing(3),
    '& a': {
      textDecoration: 'underline',
      color: theme.palette.primary.main,
    },
  },
  emptyState: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(8),
    '& img': {
      width: '200px',
      height: 'auto',
    },
    '& h2': {
      fontSize: '34px',
      maxWidth: '550px',
      fontWeight: 600,
    },
  },
}));

export const AdminPlaylistsList: FC = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  return (
    <Box>
      <AdminHeader
        title="Playlists (Beta)"
        subtitle="Group courses into playlists to assign and organize content for learners."
        actionButtons={[{label: "Create New", variant: "contained", onClick: () => navigate('/admin/playlists/create')}]}
      />
      <Typography className={classes.betaDisclaimer}>
        Rough grading complete, working towards final grade. Stand by for finish work.{' '}
        <Link to="https://portal.productboard.com/buildwitt/1-buildwitt-portal/tabs/1-recently-released/tabs/3-recently-released/submit-idea">
          Click here to provide feedback.
        </Link>
      </Typography>
      <PlaylistsListGrid />
    </Box>
  );
};

export default AdminPlaylistsList;
